import { endOfMonth, startOfMonth, subMonths } from "date-fns";
import { toLocalDateString } from "../../../utils/dateFormat";

export type DateRangePreset = "any" | "thisMonth" | "lastMonth" | "custom";

export interface DateRange {
  from: Date;
  to: Date;
}

/** "This month" / "Last month" calendar boundaries — local time, not UTC-shifted (see toLocalDateString). */
export const getPresetRange = (preset: "thisMonth" | "lastMonth"): DateRange => {
  const reference = preset === "lastMonth" ? subMonths(new Date(), 1) : new Date();
  return { from: startOfMonth(reference), to: endOfMonth(reference) };
};

/** Converts a Date range into the yyyy-MM-dd strings the backend's DateOnly? fields expect. */
export const toObtainedDateStrings = (range: DateRange | null): { obtainedFrom?: string; obtainedTo?: string } => {
  if (!range) {
    return {};
  }
  return {
    obtainedFrom: toLocalDateString(range.from),
    obtainedTo: toLocalDateString(range.to),
  };
};
